export default __webpack_public_path__ + "static/media/hub-default-user-profile.01a5d651.svg";